export default {"src":"/_next/static/media/homes.00c02d53.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};